import { ThemeOptions } from '@mui/material/styles/createTheme';
import { languageResources } from 'locales';
import { default_routes, default_theme } from './default';
import { kct_routes, kct_theme } from './kct';
import { mentor_media_routes, mentor_media_theme } from './mentor_media';
import { orientica_routes, orientica_theme } from './orientica';

export const ProjectConfigs = {
	defaultLanguage: process.env.REACT_APP_DEFAULT_LANG!,
	i18nDetectionOption: {
		order: ['localStorage', 'navigator'],
	},
	i18nFallBackLanguage: (lng: string) => {
		if (lng === 'en' || lng.startsWith('en-')) return ['en_US'];
		if (['zh-HK', 'zh-TW'].includes(lng)) return ['zh_TW'];
		if (lng === 'zh' || lng.startsWith('zh-')) return ['zh_CN'];
		if (lng === 'ja' || lng.startsWith('ja-')) return ['ja_JP'];
		return [process.env.REACT_APP_DEFAULT_LANG!];
	},
	i18nLanguageResources: languageResources,
};

let theme: ThemeOptions;
let routes: {
	path: string;
	element: JSX.Element;
	header: {
		titleType?: number;
		titleContent?: string;
		leftBtnType?: number;
	};
}[];
switch (process.env.REACT_APP_CUSTOM_PROFILE) {
	case 'kct':
		theme = kct_theme;
		routes = kct_routes;
		break;
	case 'orientica':
		theme = orientica_theme;
		routes = orientica_routes;
		break;
	case 'mentor_media':
		theme = mentor_media_theme;
		routes = mentor_media_routes;
		break;
	default:
		theme = default_theme;
		routes = default_routes;
		break;
}
export { theme, routes };
